<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('articles') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_article')"
        :loading="savingArticle"
        :saving="savingArticle"
        @click="initArticle"
      />
    </div>

    <ArticleFilter
      :filter-params="articleFilterParams"
      @change="$router.push({ name: 'articles', query: { ...$event, page: 1 } }).catch(() => {})"
    />

    <BaseTableLoader :loading="!articles">
      <ArticleTable
        :items="articles"
        :pagination="articlesPagination"
        :loading="loadingArticles"
        @edit="$router.push({ name: 'editArticle', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deleteArticle"
        @click:image="viewImages"
        @click:text="viewDescription"
        @reorder="onArticleReorder"
      />
    </BaseTableLoader>

    <router-view @click:close="onTextClose" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseTableLoader from '../../components/base/BaseTableLoader';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import ArticleTable from '../../components/ArticleTable';
import ArticleFilter from './ArticleFilter';

export default {
  name: 'Articles',

  components: { ArticleFilter, ArticleTable, BaseTableLoader, BasePrimaryActionButton },

  created() {
    if (!this.articles) {
      this.fetchArticles(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.articleFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'articles'
    ) {
      this.fetchArticles(to.query);
    }
    next();
  },

  computed: mapState('articles', [
    'articles',
    'articlesPagination',
    'articleFilterParams',
    'loadingArticles',
    'savingArticle',
  ]),

  methods: {
    ...mapActions('articles', [
      'fetchArticles',
      'storeArticle',
      'reorderArticles',
      'deleteArticle',
    ]),

    initArticle() {
      this.storeArticle().then((res) => {
        this.$router.push({ name: 'editArticle', params: { id: res.data.id } });
      });
    },

    onPageChange(page) {
      const query = { ...this.articleFilterParams, page };
      this.$router.push({ name: 'articles', query });
    },

    viewImages(article) {
      this.$router.push({ name: 'articles/images', params: { id: article.id } });
    },

    viewDescription(event) {
      this.$router.push({
        name: 'articles/text',
        params: { id: event.id },
      });
    },

    onTextClose() {
      this.$router.push({ name: 'articles', query: this.articleFilterParams });
    },

    onArticleReorder(newIndex, oldIndex) {
      this.reorderArticles({ oldIndex, newIndex });
    },
  },
};
</script>

<style scoped></style>
